import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { isExperimentEnabled } from '@wix/communities-blog-client-common';
import { EXPERIMENT_UNIFY_POSTS_EMPTY_STATES } from '@wix/communities-blog-experiments';
import EmptyStates from '../../components/empty-states';
import { useSelector } from '../../components/runtime-context';
import { getQueryLocale } from '../../selectors/locale-selectors';
import { isEditor } from '../../store/basic-params/basic-params-selectors';

type Props = React.ComponentProps<typeof EmptyStates>;

const NoPostsFeed: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const state = useSelector((s) => ({
    isMultilingual: Boolean(getQueryLocale(s)),
    isEditor: isEditor(s),
    unifyEmptyStatesExperimentEnabled: isExperimentEnabled(
      s,
      EXPERIMENT_UNIFY_POSTS_EMPTY_STATES,
    ),
  }));
  const title = state.isMultilingual
    ? t('no-posts-feed.no-published-posts-multilingual')
    : state.unifyEmptyStatesExperimentEnabled && state.isEditor
    ? t('no-posts-feed.no-posts-to-show')
    : t('no-posts-feed.on-the-way');

  const content =
    state.unifyEmptyStatesExperimentEnabled && state.isEditor
      ? t('no-posts-feed.publish-posts-to-see-them')
      : t('no-posts-feed.stay-tuned');

  return <EmptyStates {...props} title={title} content={content} />;
};

export default NoPostsFeed;
